import { useState } from 'react';
import { Icon } from '../Icon';
import { Input } from '../Input';
import { Message, MessageStack } from '../Message';
import { AccountMenu } from '../ProductNavigation';
import styles from './AdminNavigation.module.css';

/**
 * 管理后台 56px 顶栏。左侧栏不再单独实现：后台的「主菜单 + 当前功能二级菜单」两列
 * 直接用 `ModuleSidebar` 的 `appearance="admin"` 外观，见 `src/pages/admin`。
 */
export function AdminHeader({ logoSrc, assistantSrc, avatarSrc, badgeSrc }: { logoSrc: string; assistantSrc: string; avatarSrc: string; badgeSrc: string }) {
  const [query, setQuery] = useState('');
  const [notice, setNotice] = useState('');
  return <header className={styles.header}>
    <a aria-label="管理后台首页" className={styles.logoLink} href="#/admin"><img alt="校管家" className={styles.logo} src={logoSrc} /></a>
    <div className={styles.title}><Icon name="setting" size="md" /><span>管理后台-深圳市快乐学教育集团</span></div>
    <div className={styles.search}>
      <Input ariaLabel="搜索功能、字段、规则" className={styles.searchInput} leadingIcon="search" onPressEnter={() => setNotice('搜索功能待开放')} onValueChange={setQuery} placeholder="搜索功能、字段、规则" value={query} />
      <img alt="" className={styles.assistant} src={assistantSrc} />
    </div>
    <div className={styles.actions}>
      <a className={styles.returnLink} href="#/projects">返回教务系统</a>
      <button aria-label="帮助中心" className={styles.help} onClick={() => setNotice('帮助中心待开放')} type="button"><Icon name="bangzhuzhongxin" size="md" /></button>
      <div className={styles.account}><AccountMenu avatarSrc={avatarSrc} /><img alt="企业版" className={styles.badge} src={badgeSrc} /></div>
    </div>
    <MessageStack><Message message={notice} onOpenChange={(open) => { if (!open) setNotice(''); }} open={Boolean(notice)} /></MessageStack>
  </header>;
}
